import React, { useState, useEffect, useCallback } from 'react';
import { Flex, Heading, Text, Button, Image, View } from '@aws-amplify/ui-react';
import { FiArrowRight } from 'react-icons/fi';
import logo from '../logo.png'; 

const PromoBanner = () => {
    // Estado inicial: Vacío para esperar los datos del CRM
    const [promo, setPromo] = useState({
        title: "",
        type: "",
        link: "",
        active: false
    });

    const loadBannerData = useCallback(() => {
        const saved = localStorage.getItem('globalBanner');
        if (saved) {
            const parsed = JSON.parse(saved);
            setPromo(parsed);
        }
    }, []);

    useEffect(() => {
        loadBannerData();
        // Escucha el "grito" del CRMManager
        window.addEventListener('bannerUpdated', loadBannerData);
        // Escucha si se cambia en otra pestaña
        window.addEventListener('storage', loadBannerData);
        
        return () => {
            window.removeEventListener('bannerUpdated', loadBannerData);
            window.removeEventListener('storage', loadBannerData);
        };
    }, [loadBannerData]);

    // SI EL ADMINISTRADOR LO DESACTIVA O NO HAY TÍTULO, NO RENDERIZAMOS NADA
    if (!promo.active || !promo.title) return null;

    const bannerStyle = {
        background: 'linear-gradient(135deg, #1a1a1a 0%, #000 100%)',
        border: '2px solid #D4AF37',
        borderRadius: '20px',
        padding: '25px',
        marginBottom: '30px',
        boxShadow: '0 10px 30px rgba(0,0,0,0.5)',
        position: 'relative',
        overflow: 'hidden'
    };

    return (
        <Flex 
            style={bannerStyle} 
            alignItems="center" 
            justifyContent="space-between" 
            direction={{ base: 'column', medium: 'row' }}
            gap="20px"
            className="fade-in"
        >
            <Flex alignItems="center" gap="25px" direction={{ base: 'column', medium: 'row' }} textAlign={{ base: 'center', medium: 'left' }}>
                <View style={{ minWidth: '100px', height: '100px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <Image src={logo} alt="Promo" height="100px" width="100px"
                        style={{ filter: 'drop-shadow(0 0 12px rgba(212, 175, 55, 0.6))', objectFit: 'contain' }} 
                    />
                </View>
                <View>
                    <span style={{ color: '#D4AF37', fontSize: '11px', fontWeight: '900', letterSpacing: '3px', textTransform: 'uppercase' }}>
                        ANUNCIO: {promo.type}
                    </span>
                    <Heading level={3} style={{ color: 'white', margin: '5px 0', fontSize: '1.5rem', fontWeight: '600' }}>
                        {promo.title} 
                    </Heading>
                    <Text style={{ color: '#b0b0b0', maxWidth: '500px', fontSize: '14px' }}>
                        Haga clic en el botón para obtener más información sobre esta oferta activa.
                    </Text>
                </View>
            </Flex>
            <Button 
                onClick={() => window.open(promo.link || "#", "_blank")}
                style={{ backgroundColor: '#D4AF37', color: 'black', fontWeight: 'bold', border: 'none', borderRadius: '12px', padding: '12px 30px', cursor: 'pointer' }}
            >
                VER DETALLES <FiArrowRight style={{ marginLeft: '10px' }}/>
            </Button>
        </Flex>
    );
};

export default PromoBanner;